/**
 * 认证 API
 */

import apiClient from './client';
import { useAuthStore } from '../store/authStore';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  nickname?: string;
  code: string;
}

export interface AuthResponse {
  user: {
    id: string;
    email: string;
    nickname?: string;
  };
  token: string;
  expiresIn: number;
}

export interface UserInfo {
  id: string;
  email: string;
  nickname?: string;
  status: string;
  group_count: number;
  total_robots: number;
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
  error?: {
    code: string;
    message: string;
  };
}

/**
 * 用户登录
 */
export async function login(data: LoginRequest): Promise<AuthResponse> {
  const response: ApiResponse<AuthResponse> = await apiClient.post('/auth/login', data);
  
  if (response.success && response.data) {
    const { user, token } = response.data;
    useAuthStore.getState().login(user, token);
  }
  
  return response.data!;
}

/**
 * 用户注册
 */
export async function register(data: RegisterRequest): Promise<AuthResponse> {
  const response: ApiResponse<AuthResponse> = await apiClient.post('/auth/register', data);
  
  if (response.success && response.data) {
    const { user, token } = response.data;
    useAuthStore.getState().login(user, token);
  }
  
  return response.data!;
}

/**
 * 获取当前用户信息
 */
export async function getMe(): Promise<UserInfo> {
  const response: ApiResponse<UserInfo> = await apiClient.get('/auth/me');
  return response.data!;
}

/**
 * 用户登出
 */
export async function logout(): Promise<void> {
  try {
    await apiClient.post('/auth/logout');
  } finally {
    useAuthStore.getState().logout();
  }
}

/**
 * 修改密码
 */
export async function changePassword(
  currentPassword: string,
  newPassword: string
): Promise<void> {
  await apiClient.put('/auth/password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
}
